var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$role([], _vm.$store.state.user.role))?_c('v-container',{staticClass:"py-0 py-sm-8 px-0 px-sm-4"},[(_vm.$route.params.page === 'main-banner')?_c('FeatureBanner'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }